module.exports = __webpack_public_path__ + "img/10-06-04_RFEM-Spannungen_ohne_Skala.711709d2.jpg";